import styled from "styled-components/macro";
import { useCallback, useEffect } from "react";

const INPUT_TAG_VALUES = ["input", "textarea", "select"];

export default function ShortcutBadge({ onTrigger, keyValue, label }) {
  const onKeyDown = useCallback(
    (event) => {
      const activeElementTag = document.activeElement.tagName.toLowerCase();
      if (!INPUT_TAG_VALUES.includes(activeElementTag) && event.key === keyValue) {
        onTrigger();
      }
    },
    [keyValue, onTrigger]
  );

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);

    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);

  return (
    <Badge>
      {label} <span>{keyValue}</span>
    </Badge>
  );
}

export const Badge = styled.span`
  position: relative;
  top: -2px;
  font-size: 0.65em;
  font-weight: normal;
  border: solid 1px var(--grey-3);
  background-color: var(--document-background-hover);
  padding: 0.4em 0.4em;
  color: var(--grey-0);
  border-radius: 6px;

  span {
    font-size: 0.9em;
    margin-left: 0.2em;
    padding: 1px 4px;
    border-radius: 4px;
    border: solid 1px var(--grey-2);
    background-color: var(--document-background-hover);
    color: var(--grey-1);
    text-shadow: 0 0 black;
    text-transform: uppercase;
  }
`;
